import throttle from 'lodash.throttle';
import { useState, useEffect, useMemo } from 'react';
import { buildRenderingRequest } from '@rendering/product-preview';
import { getDevicePixelRatio } from '../utils/devicePixelRatio';
export function useThrottledRenderingUrl(_ref) {
  let {
    user,
    view,
    renderOptions,
    containerWidth,
    cimDocUrl,
    throttleWaitMs
  } = _ref;
  const [throttledUrl, setThrottledUrl] = useState();
  const buildThrottledUrl = useMemo(() => throttle(_ref2 => {
    let {
      user,
      view,
      renderOptions,
      containerWidth,
      cimDocUrl
    } = _ref2;
    const renderingRequest = buildRenderingRequest({
      cimDocUrl,
      referer: user.referer,
      tenantId: user.tenant.id,
      view,
      width: containerWidth,
      bgColor: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.bgColor,
      format: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.format
    });
    setThrottledUrl(renderingRequest);
  }, throttleWaitMs), [throttleWaitMs]);
  useEffect(() => {
    if (!containerWidth) {
      return;
    }
    buildThrottledUrl({
      user,
      view,
      renderOptions,
      containerWidth: containerWidth * getDevicePixelRatio(),
      cimDocUrl
    });
  }, [buildThrottledUrl, user, view, renderOptions, containerWidth, cimDocUrl]);
  return throttledUrl;
}